import {
  COMPANY_ADMIN_ADD_USER_TO_BRAND,
  COMPANY_ADMIN_EDIT_POST,
  COMPANY_ADMIN_REMOVE_POST,
  COMPANY_ADMIN_REMOVE_USER_FROM_COMPANY,
  COMPANY_ADMIN_REMOVE_USER_FROM_BRAND,
  COMPANY_ADMIN_SET_USERS,
  EDIT_BRAND,
  COMPANY_ADMIN_SET_NEW_COMPANY_ADMIN,

} from '../constants/action-types/company-admin';

export const companyAdminSetUsers = users => {
  return {
    type: COMPANY_ADMIN_SET_USERS,
    payload: users,
  };
};

export const companyAdminSetNewAdmin = newAdmin => {
  return {
    type: COMPANY_ADMIN_SET_NEW_COMPANY_ADMIN,
    payload: newAdmin,
  };
};

export const companyAdminEditPost = (newPost, oldPost) => {
  return {
    type: COMPANY_ADMIN_EDIT_POST,
    payload: { newPost, oldPost },
  };
};

export const companyAdminDeletePost = post => {
  return {
    type: COMPANY_ADMIN_REMOVE_POST,
    payload: post,
  };
};

export const companyAdminDeleteUser = user => {
  return {
    type: COMPANY_ADMIN_REMOVE_USER_FROM_COMPANY,
    payload: user,
  };
};

export const companyAdminRemoveUserFromBrand = (user, brand) => {
  return {
    type: COMPANY_ADMIN_REMOVE_USER_FROM_BRAND,
    payload: { user, brand },
  };
};

export const companyAdminAddUserToBrand = (user, brand) => {
  return {
    type: COMPANY_ADMIN_ADD_USER_TO_BRAND,
    payload: { user, brand },
  };
};

export const companyAdminEditBrand = newBrand => {
  return {
    type: EDIT_BRAND,
    payload:  newBrand ,
  };
};